import {alpha} from "@mui/material/styles";

import {THEME_MODE} from "../../../@constants";

const overrideDrawerStyles = theme => {
    const isLight = theme.palette.mode === THEME_MODE.LIGHT;

    return {
        MuiDrawer: {
            styleOverrides: {
                root: ({ ownerState }) => ({
                    zIndex: 1300,
                    ...(ownerState.variant === 'temporary' && {
                        '& .MuiDrawer-paper': {
                            boxShadow: `-40px 40px 80px -8px ${alpha(
                                isLight ? theme.palette.grey[500] : theme.palette.common.black,
                                0.24
                            )}`
                        }
                    })
                })
            }
        }
    }
}

export default overrideDrawerStyles